<script>

import Vue from 'vue/dist/vue.common.js';
import VueResource from 'vue-resource';
import store from '../vuex/store';

// components
import Icon from './icon';

Vue.use(VueResource);

export default {
  store,
  data() {
    return {
      target: ''
    }
  },
  components: {
    Icon
  },
  computed: {
    favorites () { return this.$store.state.favorites.favorites; },
  },
  watch: {
    target() {
      this.$el.querySelector('svg').remove();
      window.location = this.target;
    }
  },
  mounted() {
    this.$store.dispatch('favorites/get');
  },
}
</script>

<template lang="html">
  <div class="Favorites" style="clear: both;">
    <select  v-model="target" class="Favorites-select" name="">
      <option value="">Favorites</option>
      <option v-for="(item, index) in favorites" :value="item.node.path">{{ item.node.display_name }}</option>
    </select>
    <icon icon="arrow-down"></icon>
  </div>
</template>



// WEBPACK FOOTER //
// favorites.vue?0090c333